export default __webpack_public_path__ + "static/media/diameter.0117b7aa.svg";